import { useUpdate } from '@refinedev/core';
import { useQueryClient } from '@tanstack/react-query';
import { CreateFamilyPayload } from './useCreateFamily';

type UpdateFamilyPayload = Partial<CreateFamilyPayload>;

export function useUpdateFamily() {
  const queryClient = useQueryClient();
  const { mutateAsync, error, isLoading, reset } =
    useUpdate<UpdateFamilyPayload>();

  const updateFamily = async (id: string, values: UpdateFamilyPayload) => {
    return mutateAsync(
      {
        resource: 'families',
        id,
        values,
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({
            predicate: (query) =>
              query.queryKey.some(
                (key) => typeof key === 'string' && key.includes('families'),
              ),
          });
        },
      },
    );
  };

  return {
    updateFamily,
    error,
    isLoading,
    reset,
  };
}
